const __default__ = {
  name: "ForumSwitch",
  computed: { ...mapState(["school"])
  }
};
import { ref } from "vue";
import { getData } from "@/services/axios";
import { mapState } from "vuex"; // import RowItem from "@/components/RowItem.vue";

import ForumArticle from "@/components/forums/ForumArticle.vue";
import { storeToRefs } from "pinia";
import { useSchoolPlanStore } from "@/stores/schoolPlan";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    // @ts-check
    const {
      schoolPlan
    } = storeToRefs(useSchoolPlanStore());
    const forumList = ref([]);

    const setData = async () => {
      try {
        const data = await getData(`school_forums?from=2023-04-01&to=2024-03-31`);
        forumList.value = data.items;
      } catch (error) {
        console.log(error);
      }
    };

    setData();
    return {
      __sfc: true,
      schoolPlan,
      forumList,
      setData,
      ForumArticle
    };
  }

});